import { useSimpleReducer } from "common/hooks/useSimpleReducer";
import { GameMode, PlayersNumber, Role, Room } from "types/Room/type";
import React, { PropsWithChildren, createContext } from "react";
import { Player } from "service/player/type";
import { Character } from "types/Character/type";
import { Sheet } from "service/sheet/type";
import { DraftCharacter } from "types/Draft/type";

/*
  Forme du payload `draft-pool` : les persos encore en jeu, avec pour chacun si le joueur
  courant peut le sélectionner maintenant. Le serveur en est la seule source — les règles
  (bans, picks, bans joker, possession) ne sont plus calculées ici.
*/
export type DraftPoolEntry = DraftCharacter & { selectable: boolean };

type RoomSocket = Room & {
  localPlayer?: Player;
  role: Role;
  charactersList: Character[];
  availableSheets: Sheet[];
  admin: boolean;
  konami: boolean;
  draftPool: DraftPoolEntry[];
};

type RoomContextType = RoomSocket & {
  dispatch: (action: Partial<RoomSocket>) => void;
};

export const defaultValues: RoomContextType = {
  localPlayer: undefined,
  role: "Spectator",
  params: {
    name: "",
    privateRoom: false,
    sheet: {
      name: "",
      id: 0,
    },
    gameMode: GameMode.SpiralAbyss,
    playersNumber: PlayersNumber._1vs1,
  },
  draftModel: {
    banShared: false,
    pickShared: false,
    timer: 0,
    steps: [],
    preparationTimer: 0,
  },
  spectators: [],
  dispatch: () => {},
  player1: undefined,
  player2: undefined,
  player3: undefined,
  player4: undefined,
  teamBoxPlayer1: undefined,
  teamBoxPlayer2: undefined,
  balancingBansPlayer1: undefined,
  jokerBansPlayer1: undefined,
  balancingBansPlayer2: undefined,
  jokerBansPlayer2: undefined,
  admin: false,
  konami: false,
  charactersList: [],
  availableSheets: [],
  draftPool: [],
};
export const RoomContext = createContext<RoomContextType>(defaultValues);

export const RoomProvider = (
  props: PropsWithChildren<Partial<RoomContextType>>
) => {
  const [state, dispatch] = useSimpleReducer<RoomContextType>({
    ...defaultValues,
    ...props,
  });

  return (
    <RoomContext.Provider value={{ ...state, dispatch }}>
      {props.children}
    </RoomContext.Provider>
  );
};
